import { useEffect, useState } from "react";
import { useNavigate, useParams, useSearchParams } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { comnUtils } from "@/comn/utils"; // 프로젝트 공통 유틸
import { Page, Group, Layout, Button, Grid } from "@/comn/components"; // 화면 구성 컴포넌트
import { useFetch, useForm, useAuth, useStore, useToast, useResource, useModal, usePage, useGrid } from "@/comn/hooks";
import { APIS, SF_MY_INFO_CHG_INFO } from "@/tra/tancis/ptli/mypage/myinfochg/service/PtliMyInfoChgService";
import { usePwdAuth } from "@/comn/hooks/usePwdAuth";
import * as cstmOfcrService from "@/tra/tancis/ptli/usr/cstmofcr/services/PtliCstmOfcrService";

/*
 * Edit my information
 * !== 나의 정보 수정 ==!
 */
export const PTLI0307001S = () => {
    const { pgeUid, menuId } = usePage({
        auth: ["auth_ptli0019"],
    });
    const { t } = useTranslation();
    const navigate = useNavigate();
    const modal = useModal(); // Modal Window Hook !== Modal 창 Hook ==!
    const {} = useStore({ pgeUid: pgeUid }); // Page Store Hook !== 화면 데이터 저장 Hook ==!
    const toast = useToast();
    const auth = useAuth(); // Login , User Information Hook !== 로그인, 유저정보 Hook ==!
    const { usrDmnId } = useParams(); // Key Information of this Component Router !== 라우터에 정의된 키정보 ==!
    const [searchParams] = useSearchParams();

    const pwdAuth = usePwdAuth({
        auto: false,
        callback: () => setBtns((btns: any) => ({ ...btns, pwdAuthChk: true })),
    });

    // Initial data (Check customs information change status) !== 초기 데이터 (세관정보 변경사항 체크용) ==!
    const [cstmDatas, setCstmData] = useState({ cstmOfceCd: "", cstmSctnOrgzCd: "", cstmUnitOrgzCd: "", roleId: "" });

    const [btns, setBtns] = useState({ regist: false, pwdAuthChk: false, elecAprv: false });
    const [aprvTp, setAprvTp] = useState("");

    /*
     * Declaration Hook, Meta
     * !== Hook, 메타 정보 정의 ==!
     */
    useResource({
        defaultSchema: [{ area: "comnCd", comnCd: "PTL0003" }, { area: "cstmCd" }, { area: "orgzSub" }],
    });

    /*
     * Declaration Form
     * !== 폼 정의 ==!
     */
    const form = {
        // My information modification form !== 나의정보 수정 폼 ==!
        myInfoChgInfo: useForm({ defaultSchema: SF_MY_INFO_CHG_INFO }),
    };

    /*
     * Declaration Grid
     * !== Grid 정의 ==!
     */
    const grid = { usrCstmList: useGrid({ defaultSchema: cstmOfcrService.SG_USR_CSTM_LIST }) };

    /*
     * Declaration Fetch
     * !== Fetch 정의 ==!
     */
    const fetch = {
        // Search user registration application information based on login ID !== 로그인ID 기준 사용자 정보 조회==!
        getMyInfo: useFetch({
            api: (data: any) => APIS.getMyInfo(data),
            enabled: false,
            onSuccess: (data) => {
                if (comnUtils.isEmpty(data.myInfo.content)) return;
                handler.getCstmList("Y");

                // Initial data setting (to check changes) !== 초기 데이터 세팅 (변경사항 체크용) ==!
                const initMyInfoData = data.myInfo.content;

                if (menuId === "elecAprv" || initMyInfoData.aprvPrcssStatCd == "A01") {
                    initMyInfoData.cstmSctnOrgzCd = initMyInfoData.aplyCstmSctnOrgzCd;
                    initMyInfoData.cstmOfceCd = initMyInfoData.aplyCstmOfceCd;
                    initMyInfoData.cstmUnitOrgzCd = initMyInfoData.aplyCstmUnitOrgzCd;
                    initMyInfoData.roleId = initMyInfoData.aplyRoleId;
                }

                const { cstmOfceCd, cstmSctnOrgzCd, cstmUnitOrgzCd, roleId } = initMyInfoData;
                setCstmData(() => ({ cstmOfceCd, cstmSctnOrgzCd, cstmUnitOrgzCd, roleId }));

                form.myInfoChgInfo.setValues({ ...initMyInfoData, fileGrpUuid: initMyInfoData.usrDmnId });
                fetch.getUsrCstmList.fetch(auth.get("usrId"));

                setBtns((btns: any) => ({
                    ...btns,
                    elecAprv: menuId === "elecAprv",
                    regist: initMyInfoData.aprvYn === "Y",
                }));
            },
            onError: (error) => {
                if (error.response.status === 400) {
                    const { errorMessage } = error.response.data;

                    modal.openModal({
                        content: errorMessage.content,
                        onConfirm: () => navigate("/"),
                        close: false,
                    });

                    return;
                }

                toast.showToast({ type: "error", content: "msg.com.00018" }); // An error occurred. !== 에러가 발생했습니다! ==!
            },
        }),

        // Section search by customs !== 섹션별 세관 조회 ==!
        getCstmList: useFetch({
            api: () => APIS.getOrgzList(form.myInfoChgInfo.getValues()),
            enabled: false,
            onSuccess: (data) => {
                if (data.orgzList.content.length > 0) {
                    // 여기서 array 집어 넣어야함
                    form.myInfoChgInfo.setValue(
                        "cstmOfceCdArr",
                        data.orgzList.content.map((item: any) => item.cstmOrgzCd),
                    );
                }
                handler.getUnitList(form.myInfoChgInfo.getValue("loadYn"));
                //handler.getAprvUsrList();
            },
            onError: () => {},
        }),

        // unit search by section !== 섹션별 유닛 조회 ==!
        getUnitList: useFetch({
            api: () => APIS.getOrgzList(form.myInfoChgInfo.getValues()),
            enabled: false,
            onSuccess: (data) => {
                if (data.orgzList.content.length > 0) {
                    form.myInfoChgInfo.setSchema("cstmUnitOrgzCd", {
                        options: data.orgzList.content.map((item: any) => ({
                            label: item.cstmOrgzNm,
                            value: item.cstmOrgzCd,
                        })),
                    });
                }
                handler.getCstmRoleList(form.myInfoChgInfo.getValue("loadYn"));
            },
            onError: () => {},
        }),

        getUsrCstmList: useFetch({
            api: (usrDmnId) => cstmOfcrService.APIS.getUsrCstmList(usrDmnId),
            onSuccess: () => {},
            onError: () => {},
        }),

        // Update User Information !== 사용자 정보 수정 ==!
        updateMyInfo: useFetch({
            api: (data) => APIS.saveMyInfo({ ...data }),
            onSuccess: () => {
                // Successfully saved., !== 정상적으로 저장되었습니다. ==!
                modal.openModal({ content: "msg.com.00062" });
                form.myInfoChgInfo.setValues({ usrPwd: "", usrPwdCfrm: "" });
            },
            onError: (error) => {
                if (error.response.status === 400) {
                    form.myInfoChgInfo.setErrors(error.response.data.errors);
                    return;
                }

                const { errorCode, errorMessage } = error.response.data;

                if (errorCode === "-999") {
                    // Passwords do not match !== 비밀번호가 일치하지 않습니다. ==!
                    modal.openModal({ content: errorMessage });

                    form.myInfoChgInfo.setFocus("usrPwdCfrm");
                    return;
                }

                toast.showToast({ type: "error", content: "msg.com.00018" }); // An error occurred. !== 에러가 발생했습니다! ==!
            },
        }),

        // Enter the payment ID in the user application information. !== 사용자 신청 정보에 결재아이디를 넣어준다. ==!
        saveUsrAplyId: useFetch({
            api: (data) => APIS.saveUsrAplyId({ ...data }),
            onSuccess: () => {
                if (comnUtils.isEmpty(auth.get("usrId"))) {
                    /**
                     * If there is no user information, go to the main page
                     * !== 사용자 정보가 없는 경우 메인페이지로 이동한다 ==!
                     */
                    modal.openModal({
                        content: "msg.com.00105",
                        onConfirm: () => navigate("/"),
                        close: false,
                    });
                } else {
                    form.myInfoChgInfo.setValue("aprvPrcssStatCdNm", "Requested");

                    modal.openModal({
                        content: "msg.ptl.00814",
                    });
                }
            },
            onError: (error) => {
                if (error.response.status === 400) {
                    form.myInfoChgInfo.setErrors(error.response.data.errors);
                }

                modal.openModal({ content: "msg.00006" }); // An error occurred during processing.
            },
        }),

        // Save User Registration Applications !== 사용자 등록 신청 저장 ==!
        saveUsrRgsrAply: useFetch({
            api: (data) => APIS.saveUsrRgsrAply({ ...data }),
            onSuccess: () => {
                handler.saveUsrAplyId();
            },
            onError: (error) => {
                if (error.response.status === 400) {
                    form.myInfoChgInfo.setErrors(error.response.data.errors);
                }
                modal.openModal({ content: "msg.00006" }); // An error occurred during processing.
            },
        }),

        // Section search by customs role !== 조직 역할 목록 조회 ==!
        getCstmRoleList: useFetch({
            api: (objParam) => APIS.getCstmRoleList(objParam),
            enabled: false,
            onSuccess: (data) => {
                if (data?.cstmRoleList?.content.length > 0) {
                    form.myInfoChgInfo.setSchema("roleId", {
                        options: data.cstmRoleList.content.map((item: any) => ({
                            label: item.roleNm,
                            value: item.roleId,
                        })),
                    });
                } else {
                    form.myInfoChgInfo.setSchema("roleId", { options: [] });
                    form.myInfoChgInfo.setValue("roleId", "");
                }
            },
            onError: () => {},
        }),

        getAprvUsrList: useFetch({
            api: () => APIS.getAprvUsrList(form.myInfoChgInfo.getValues()),
            enabled: false,
            onSuccess: (data) => {
                if (data.aprvUsrList.content.length > 0) {
                    // 여기서 array 집어 넣어야함
                    form.myInfoChgInfo.setValue(
                        "aprvUsrList",
                        data.aprvUsrList.content.map((item: any) => item.usrDmnId),
                    );
                }
                //console.log(form.myInfoChgInfo.getValue("aprvUsrList"));
            },
            onError: () => {},
        }),

        // Get Section manager Y/N !== 섹션매니저 여부 조회 ==!
        getSctnMngrYn: useFetch({
            api: (data) => APIS.getSctnMngrYn(data),
            enabled: false,
            onSuccess: (data) => {
                // Approver setting !== 결재자 세팅 ==!
                const sctnMngrYn = data.sctnMngrYn.content;
                const sctnCd = form.myInfoChgInfo.getValue("cstmSctnOrgzCd");
                if (sctnCd == "CBS") {
                    // Section : CBS
                    form.myInfoChgInfo.setValue("authAprvRqstList", [
                        { aprvPrcssOrd: "1", usrDmnId: "auth_ptli0037" }, // CAS MANAGER
                    ]);
                } else if (sctnCd == "DC") {
                    // Section : DC(DEPUTY COMMISSIONERS)
                    form.myInfoChgInfo.setValue("authAprvRqstList", [
                        { aprvPrcssOrd: "1", usrDmnId: "auth_ptli0039" }, // CCE
                        { aprvPrcssOrd: "2", usrDmnId: "auth_ptli0037" }, // CAS MANAGER
                    ]);
                } else if (sctnMngrYn == "Y") {
                    // Role : Section Manager
                    form.myInfoChgInfo.setValue("authAprvRqstList", [
                        { aprvPrcssOrd: "1", usrDmnId: "auth_ptli0035" }, // DCCO
                        { aprvPrcssOrd: "2", usrDmnId: "auth_ptli0038" }, // CAS OFFICER
                        { aprvPrcssOrd: "3", usrDmnId: "auth_ptli0037" }, // CAS MANAGER
                    ]);
                } else {
                    // Role : Officer
                    form.myInfoChgInfo.setValue("authAprvRqstList", [
                        { aprvPrcssOrd: "1", usrDmnId: "auth_ptli0030", cstmSctnOrgzCd: sctnCd }, // SECTION MANAGER
                        { aprvPrcssOrd: "2", usrDmnId: "auth_ptli0038" }, // CAS OFFICER
                        { aprvPrcssOrd: "3", usrDmnId: "auth_ptli0037" }, // CAS MANAGER
                    ]);
                }

                handler.onAprvRqstBtnClick();
            },
            onError: () => {},
        }),
    };

    /*
     * Declaration Event Handler
     * !== 이벤트 핸들러 정의 ==!
     */
    const handler = {
        checkPwd: () => {
            const usrPwd = form.myInfoChgInfo.getValue("usrPwd");
            const usrPwdCfrm = form.myInfoChgInfo.getValue("usrPwdCfrm");

            if (!comnUtils.isEmpty(usrPwd) && !comnUtils.equals(usrPwd, usrPwdCfrm)) {
                form.myInfoChgInfo.setError("usrPwdCfrm", {
                    message: "msg.ptl.00712", // Passwords do not match. !== 비밀번호가 일치하지 않습니다. ==!
                    type: "error",
                });
            } else {
                form.myInfoChgInfo.clearErrors("usrPwdCfrm");
            }
        },

        // Section search by customs !== 섹션별 세관 조회 ==!
        getCstmList: (loadYn: any) => {
            if (loadYn !== "Y") {
                form.myInfoChgInfo.setSchema("cstmOfceCd", { options: [] });
                form.myInfoChgInfo.setSchema("cstmUnitOrgzCd", { options: [] });
                form.myInfoChgInfo.setSchema("roleId", { options: [] });

                form.myInfoChgInfo.setValue("cstmOfceCd", "");
                form.myInfoChgInfo.setValue("cstmUnitOrgzCd", "");
                form.myInfoChgInfo.setValue("roleId", "");
            }

            form.myInfoChgInfo.setValue("cstmOrgzTpCd", "C");
            form.myInfoChgInfo.setValue("loadYn", "Y");

            fetch.getCstmList.fetch();
        },

        // unit search by section !== 세관별 유닛 조회 ==!
        getUnitList: (loadYn: any) => {
            if (loadYn !== "Y") {
                form.myInfoChgInfo.setSchema("cstmUnitOrgzCd", { options: [] });
                form.myInfoChgInfo.setSchema("roleId", { options: [] });
                form.myInfoChgInfo.setValue("cstmUnitOrgzCd", "");
                form.myInfoChgInfo.setValue("roleId", "");
            }

            form.myInfoChgInfo.setValue("cstmOrgzTpCd", "U");
            form.myInfoChgInfo.setValue("loadYn", "Y");

            fetch.getUnitList.fetch();
        },

        // Update User Information !== 사용자 정보 수정 ==!

        //세이브 버튼 클릭 시, change Affiliation 부분 required를 false로
        onSaveBtnClick: () => {
            form.myInfoChgInfo.setSchema("cstmSctnOrgzCd", { required: false });
            form.myInfoChgInfo.setSchema("cstmOfceCd", { required: false });
            form.myInfoChgInfo.setSchema("roleId", { required: false });

            if (!comnUtils.isEmpty(form.myInfoChgInfo.errors)) {
                const data = form.myInfoChgInfo.getValues();

                if (!comnUtils.isEmpty(data.usrPwd) || !comnUtils.isEmpty(data.usrPwd)) {
                    toast.showToast({ type: "warning", content: "msg.00002" }); // Data is invalid, !== 데이터가 유효하지않습니다. ==!
                    return;
                }
            }

            form.myInfoChgInfo.handleSubmit(
                () => {
                    const data = form.myInfoChgInfo.getValues();
                    const usrPwd = data.usrPwd;
                    const usrPwdCfrm = data.usrPwdCfrm;

                    // Check for missing password !== 비밀번호 누락 여부 체크 ==!
                    if (!comnUtils.isEmpty(usrPwd) && comnUtils.isEmpty(usrPwdCfrm)) {
                        toast.showToast({ type: "warning", content: "msg.00002" });
                        form.myInfoChgInfo.setFocus("usrPwdCfrm");
                        return;
                    }

                    if (comnUtils.isEmpty(usrPwd) && !comnUtils.isEmpty(usrPwdCfrm)) {
                        toast.showToast({ type: "warning", content: "msg.00002" });
                        form.myInfoChgInfo.setFocus("usrPwd");
                        return;
                    }

                    if (typeof data.fileGrpUuid === "object") {
                        data.fileSaveDto = data.fileGrpUuid;
                        data.fileGrpUuid = null;
                    }

                    console.log(form.myInfoChgInfo.getValues());

                    modal.openModal({
                        content: "msg.00101", // Do you want to save ? !== 저장 하시겠습니까 ? ==!
                        onConfirm: () => fetch.updateMyInfo.fetch(data),
                    });
                },
                () => toast.showToast({ type: "warning", content: "msg.00002" }), // Data is invalid, !== 데이터가 유효하지않습니다. ==!
            )();
        },

        // Enter the payment ID in the user application information. !== 사용자 신청 정보에 결재아이디를 넣어준다. ==!
        saveUsrAplyId: () => {
            if (!comnUtils.isEmpty(form.myInfoChgInfo.errors)) {
                toast.showToast({ type: "warning", content: "msg.00002" }); // Data is invalid, !== 데이터가 유효하지않습니다. ==!
                return;
            }

            form.myInfoChgInfo.handleSubmit(
                () => {
                    const data = form.myInfoChgInfo.getValues();
                    if (typeof data.fileGrpUuid === "object") {
                        data.fileSaveDto = data.fileGrpUuid;
                        data.fileGrpUuid = null;
                    }

                    fetch.saveUsrAplyId.fetch(data);
                },
                () => toast.showToast({ type: "warning", content: "msg.00002" }), // Data is invalid, !== 데이터가 유효하지않습니다. ==!
            )();
        },

        // Save User Registration Applications !== 사용자 등록 신청 저장 ==!
        saveUsrRgsrAply: () => {
            form.myInfoChgInfo.handleSubmit(
                () => {
                    const data = form.myInfoChgInfo.getValues();
                    if (typeof data.fileGrpUuid === "object") {
                        data.fileSaveDto = data.fileGrpUuid;
                        data.fileGrpUuid = null;
                    }

                    fetch.saveUsrRgsrAply.fetch(data);
                },
                () => toast.showToast({ type: "warning", content: "msg.00002" }), // Data is invalid, !== 데이터가 유효하지않습니다. ==!
            )();
        },

        // Click Approval Request Button !== 승인 요청 버튼 클릭 ==!
        onAprvRqstBtnClick: () => {
            if (!comnUtils.isEmpty(form.myInfoChgInfo.errors)) {
                toast.showToast({ type: "warning", content: "msg.00002" }); // Data is invalid, !== 데이터가 유효하지않습니다. ==!
                return;
            }

            // 내부사용자 정지요청 결재완료 후처리, 반려 후처리
            let scrnDocCdVal = "scrn_ptla0003";
            let aprvAfPrcssCfgnIdVal = "cfgn_ptl0005";
            let rjctAfPrcssCfgnIdVal = "cfgn_ptl0006";
            let aprvRqstTtleNm = "Internal user suspension request";

            if (aprvTp === "M") {
                // 내부사용자 수정 결재완료 후처리, 반려 후처리
                scrnDocCdVal = "scrn_ptla0002";
                aprvAfPrcssCfgnIdVal = "cfgn_ptl0002";
                rjctAfPrcssCfgnIdVal = "cfgn_ptl0003";
                aprvRqstTtleNm = "Edit my information";

                const data = form.myInfoChgInfo.getValues();

                // Check the customs information update status only when the approval status is not 'Rejected' !== 결재상태가 Rejected가 아닌 경우에만 세관정보 변경상태 체크 ==!
                if (form.myInfoChgInfo.getValue("aprvPrcssStatCdNm") !== "Rejected") {
                    if (
                        handler.getInfoEqTf(data.cstmOfceCd, cstmDatas.cstmOfceCd) &&
                        handler.getInfoEqTf(data.cstmSctnOrgzCd, cstmDatas.cstmSctnOrgzCd) &&
                        handler.getInfoEqTf(data.cstmUnitOrgzCd, cstmDatas.cstmUnitOrgzCd) &&
                        handler.getInfoEqTf(data.roleId, cstmDatas.roleId)
                    ) {
                        toast.showToast({ type: "warning", content: t("msg.ptl.00734", { 0: t("T_CSTM_ORGZ") }) }); // No {0: Customs Office Organizations} information has changed. !== 변경된 {조직} 정보가 없습니다. ==!
                        return;
                    }
                }
            }

            if (comnUtils.isEmpty(form.myInfoChgInfo.getValue("authAprvRqstList"))) {
                modal.openModal({
                    content: "msg.ptl.00807", // Please designate the approver. !== 결재자를 지정해주세요. ==!
                    onCancel: () => {
                        modal.postMessage({
                            aprvId: "",
                        });
                    },
                    onClose: () => {
                        modal.postMessage({
                            aprvId: "",
                        });
                    },
                });
                return;
            }

            form.myInfoChgInfo.handleSubmit(
                () => {
                    modal.openModal({
                        //url: "/comn/comn/ppup/aprvRqstDrt",
                        url: "/comn/comn/ppup/roleAprvRqstDrt",
                        params: {
                            bsopClsfCd: "PTL",
                            aprvReffId: "/" + form.myInfoChgInfo.getValue("usrDmnId"),
                            scrnDocCd: scrnDocCdVal,
                            aprvAfPrcssCfgnId: aprvAfPrcssCfgnIdVal,
                            rjctAfPrcssCfgnId: rjctAfPrcssCfgnIdVal,
                            preStageRtrnUseYn: "Y", // 이전단계 반려처리가 필요한 경우에만 'Y'로 넘겨 줄 것 (결재처리 시 이전단계반려 라디오버튼을 보여줌)
                            itsfAprvYn: "", // 업무팀 자체 결재처리 시 'Y'로 넘겨 줄 것 (결재처리탭 비활성화)
                            delYn: "N",
                            rjctStatUseYn: "Y", // 거절상태사용여부
                            aprvRqstTtleNm: aprvRqstTtleNm,
                            aprvRqstCn: "contents",
                            //aprvUsrList: form.myInfoChgInfo.getValue("aprvUsrList"),
                            authAprvRqstList: form.myInfoChgInfo.getValue("authAprvRqstList"),
                            //docNo: "",
                            docNo: form.myInfoChgInfo.getValue("usrDmnId"),
                            /*
                            // Sample Group Approval Request !== 그룹결재요청 direct 샘플 ==!
                            url: "/comn/comn/ppup/grpAprvRqstDrt",
                            params: {
                            bsopClsfCd: "PTL",
                            aprvReffId: "/" + form.myInfoChgInfo.getValue("usrDmnId"),
                            scrnDocCd: scrnDocCdVal,
                            aprvAfPrcssCfgnId: aprvAfPrcssCfgnIdVal,
                            rjctAfPrcssCfgnId: rjctAfPrcssCfgnIdVal,
                            preStageRtrnUseYn: "Y", // 이전단계 반려처리가 필요한 경우에만 'Y'로 넘겨 줄 것 (결재처리 시 이전단계반려 라디오버튼을 보여줌)
                            itsfAprvYn: "", // 업무팀 자체 결재처리 시 'Y'로 넘겨 줄 것 (결재처리탭 비활성화)
                            delYn: "N",
                            rjctStatUseYn: "N", // 거절상태사용여부
                            //aprvPrcssPathMgmtId: "APRV00000001", // 승인처리패스관리ID
                            aprvRqstTtleNm: "Edit my information",
                            aprvRqstCn: "contents",
                            grpAprvRqstList: [
                                { aprvPrcssOrd: "3", usrDmnId: "IMARANDU" },
                                { aprvPrcssOrd: "1", usrDmnId: "RMMBANDO" },
                                { aprvPrcssOrd: "3", usrDmnId: "CUO" },
                                { aprvPrcssOrd: "2", usrDmnId: "NMDENDU" },
                            ],
                            docNo: "",
                            */
                            testCallback: (data: any) => {
                                if (!comnUtils.isEmpty(data.aprvId)) {
                                    setBtns((btns: any) => ({ ...btns, regist: false }));

                                    // Modify application information after setting payment ID !== 결재ID 세팅 후 신청정보 수정 ==!
                                    form.myInfoChgInfo.setValue("aprvId", data?.aprvId);

                                    handler.saveUsrRgsrAply();
                                }

                                //modal.closeModal();
                            },
                        },
                        size: "lg",
                        draggable: true,
                        // callback: (data) => {
                        //     console.log("callback");
                        //     debugger;
                        //     if (!comnUtils.isEmpty(data.aprvId)) {
                        //         setBtns((btns: any) => ({ ...btns, regist: false }));

                        //         // Modify application information after setting payment ID !== 결재ID 세팅 후 신청정보 수정 ==!
                        //         form.myInfoChgInfo.setValue("aprvId", data?.aprvId);

                        //         handler.saveUsrRgsrAply();
                        //         handler.saveUsrAplyId();
                        //     }

                        //     modal.closeModal();
                        // },
                    });
                },
                () => toast.showToast({ type: "warning", content: "msg.00002" }), // Data is invalid, !== 데이터가 유효하지않습니다. ==!
            )();
        },

        // Section search by customs role !== 세관 역할 조회 ==!
        getCstmRoleList: (loadYn: any) => {
            if (loadYn !== "Y") {
                form.myInfoChgInfo.setSchema("roleId", { options: [] });
                form.myInfoChgInfo.setValue("roleId", "");
            }

            const cstmSctnOrgzCd = form.myInfoChgInfo.getValue("cstmSctnOrgzCd");

            // Initialize role combo if there is no section code !== 섹션 코드 없는 경우 역할 콤보 초기화 ==!
            if (comnUtils.isEmpty(cstmSctnOrgzCd)) {
                form.myInfoChgInfo.setSchema("roleId", { options: [] });
                form.myInfoChgInfo.setValue("roleId", "");
                return;
            }

            const cstmOfceCd = form.myInfoChgInfo.getValue("cstmOfceCd");
            const cstmUnitOrgzCd = form.myInfoChgInfo.getValue("cstmUnitOrgzCd");
            const cstmOrgzTpCd = comnUtils.isEmpty(cstmOfceCd) ? "S" : !comnUtils.isEmpty(cstmUnitOrgzCd) ? "U" : "C";
            const objParam = { cstmSctnOrgzCd, cstmOfceCd, cstmUnitOrgzCd, cstmOrgzTpCd };
            fetch.getCstmRoleList.fetch(objParam);
        },

        getAprvUsrList: () => {
            fetch.getAprvUsrList.fetch();
        },

        onEditBtnClick: () => {
            pwdAuth.open();
        },

        getInfoEqTf: (cs1: any, cs2: any) => {
            if (cs1 === cs2) {
                return true;
            }
            if (
                (comnUtils.isUndefined(cs1) || comnUtils.isNull(cs1)) &&
                (comnUtils.isUndefined(cs2) || comnUtils.isNull(cs2))
            ) {
                return true;
            }

            return false;
        },

        onEditInfoBtnClick: () => {
            form.myInfoChgInfo.setSchema("cstmSctnOrgzCd", {
                required: !btns.elecAprv && btns.regist && btns.pwdAuthChk,
            });
            form.myInfoChgInfo.setSchema("cstmOfceCd", { required: !btns.elecAprv && btns.regist && btns.pwdAuthChk });
            form.myInfoChgInfo.setSchema("roleId", { required: !btns.elecAprv && btns.regist && btns.pwdAuthChk });

            const roleId = form.myInfoChgInfo.getValue("roleId");
            if (comnUtils.isEmpty(roleId)) {
                toast.showToast({ type: "warning", content: t("msg.com.00038", { 0: t("L_ROLE_NM") }) }); // Please select {Role}. !== {역할명} 을(를) 선택하여 주세요. ==!
                return;
            }
            fetch.getSctnMngrYn.fetch(roleId);
        },

        onSuspdBtnClick: () => {
            // 정지요청시 현재 값을 기준으로 결재선 세팅
            const roleId = cstmDatas.roleId;
            if (comnUtils.isUndefined(roleId) || comnUtils.isNull(roleId)) {
                // 기존 ROLE_ID가 없는 경우
                const sctnCd = cstmDatas.cstmSctnOrgzCd;
                if (sctnCd == "CBS") {
                    // Section : CBS
                    form.myInfoChgInfo.setValue("authAprvRqstList", [
                        { aprvPrcssOrd: "1", usrDmnId: "auth_ptli0037" }, // CAS MANAGER
                    ]);
                } else if (sctnCd == "DC") {
                    // Section : DC(DEPUTY COMMISSIONERS)
                    form.myInfoChgInfo.setValue("authAprvRqstList", [
                        { aprvPrcssOrd: "1", usrDmnId: "auth_ptli0039" }, // CCE
                        { aprvPrcssOrd: "2", usrDmnId: "auth_ptli0037" }, // CAS MANAGER
                    ]);
                } else {
                    // Role ID Empty
                    form.myInfoChgInfo.setValue("authAprvRqstList", [
                        { aprvPrcssOrd: "1", usrDmnId: "auth_ptli0035" }, // DCCO
                        { aprvPrcssOrd: "2", usrDmnId: "auth_ptli0038" }, // CAS OFFICER
                        { aprvPrcssOrd: "3", usrDmnId: "auth_ptli0037" }, // CAS MANAGER
                    ]);
                }

                handler.onAprvRqstBtnClick();
            } else {
                fetch.getSctnMngrYn.fetch(roleId);
            }
        },
    };

    useEffect(() => {
        if (menuId === "elecAprv") {
            const aprvId = searchParams.get("aprvId");
            fetch.getMyInfo.fetch({ usrDmnId, aprvId });
            form.myInfoChgInfo.setEditable(false);
        } else {
            if (comnUtils.isEmpty(auth.get("usrId"))) {
                /**
                 * If there is no user information, go to the main page
                 * !== 사용자 정보가 없는 경우 메인페이지로 이동한다 ==!
                 */
                modal.openModal({
                    content: "msg.com.00105",
                    onConfirm: () => navigate("/"),
                    close: false,
                });
                return;
            }
            form.myInfoChgInfo.setValue("aprvPrcssPathMgmtId", "APRV00000003");
            fetch.getMyInfo.fetch({ usrDmnId: auth.get("usrId") });
            form.myInfoChgInfo.setEditable(false);
        }
    }, []);

    useEffect(() => {
        if (menuId !== "elecAprv" && btns.pwdAuthChk) {
            form.myInfoChgInfo.setEditable(["usrTelno", "usrEmlAddr", "usrPwd", "usrPwdCfrm", "fileGrpUuid"]);

            form.myInfoChgInfo.setSchemas(["cstmSctnOrgzCd", "cstmOfceCd", "cstmUnitOrgzCd", "roleId"], {
                readOnly: !btns.regist,
            });
        }
    }, [btns]);

    return (
        <Page>
            <Group>
                <Group.Body>
                    <Group.Section>
                        <Group.Title title={"L_PSN_INFO"} titleSize={2}></Group.Title>
                        <Group.Row>
                            <Group.Control {...form.myInfoChgInfo.schema.cstmOfcrNo} edit={false} />
                            <Group.Control {...form.myInfoChgInfo.schema.usrTin} edit={false} />
                        </Group.Row>
                        <Group.Row>
                            <Group.Control {...form.myInfoChgInfo.schema.usrDmnId} edit={false} />
                            <Group.Control {...form.myInfoChgInfo.schema.usrNm} edit={false} />
                        </Group.Row>
                        <Group.Row>
                            <Group.Control {...form.myInfoChgInfo.schema.usrTelno} />
                            <Group.Control {...form.myInfoChgInfo.schema.usrEmlAddr} edit={false} />
                        </Group.Row>
                        <Group.Row hidden={btns.elecAprv || !btns.pwdAuthChk}>
                            <Group.Control {...form.myInfoChgInfo.schema.usrPwd} />
                            <Group.Control {...form.myInfoChgInfo.schema.usrPwdCfrm} onBlur={handler.checkPwd} />
                        </Group.Row>
                        <Group.Row hidden={btns.elecAprv}>
                            <Group.Control {...form.myInfoChgInfo.schema.actnUsrYn} />
                        </Group.Row>
                        <Group.Row hidden={btns.elecAprv}>
                            <Group.Control {...form.myInfoChgInfo.schema.fileGrpUuid} />
                        </Group.Row>
                        <Group.Row hidden={btns.elecAprv}>
                            <Group.Control {...form.myInfoChgInfo.schema.aprvPrcssStatCdNm} edit={false} />
                            <Group.Control {...form.myInfoChgInfo.schema.aprvPrcssOpinCn} edit={false} />
                        </Group.Row>
                    </Group.Section>

                    <Group.Section>
                        <Group.Title title={"T_AFFIL"} titleSize={2}></Group.Title>
                        <Group.Row>
                            <Group.Control {...form.myInfoChgInfo.schema.cstmSctnOrgzCdNm} edit={false} />
                            <Group.Control {...form.myInfoChgInfo.schema.cstmOfceCdNm} edit={false} />
                        </Group.Row>
                        <Group.Row>
                            <Group.Control {...form.myInfoChgInfo.schema.cstmUnitOrgzCdNm} edit={false} />
                            <Group.Control {...form.myInfoChgInfo.schema.roleNm} edit={false} />
                        </Group.Row>
                    </Group.Section>

                    <Group.Section
                        hidden={
                            (!btns.elecAprv && !btns.pwdAuthChk && btns.regist) || (btns.elecAprv && btns.pwdAuthChk)
                        }
                    >
                        {/* 문제점 */}
                        <Group.Title title={"T_CHG_AFFIL"} titleSize={2} />
                        <Group.Row>
                            <Group.Control
                                {...form.myInfoChgInfo.schema.cstmSctnOrgzCd}
                                popupParams={{ cstmOrgzTpCd: "S" }}
                                onChange={() => handler.getCstmList("N")}
                                //required={!btns.elecAprv && btns.regist && btns.pwdAuthChk}
                            />
                        </Group.Row>
                        <Group.Row>
                            <Group.Control
                                {...form.myInfoChgInfo.schema.cstmOfceCd}
                                onChange={() => handler.getUnitList("N")}
                                popupParams={{ cstmOfceCdArr: form.myInfoChgInfo.getValue("cstmOfceCdArr") }}
                                //required={!btns.elecAprv && btns.regist && btns.pwdAuthChk}
                            />
                        </Group.Row>
                        <Group.Row>
                            <Group.Control
                                {...form.myInfoChgInfo.schema.cstmUnitOrgzCd}
                                onChange={() => handler.getCstmRoleList("N")}
                            />
                        </Group.Row>
                        <Group.Row>
                            <Group.Control
                                {...form.myInfoChgInfo.schema.roleId}
                                //required={!btns.elecAprv && btns.regist && btns.pwdAuthChk}
                            />
                        </Group.Row>
                    </Group.Section>

                    <Group.Section hidden={btns.elecAprv}>
                        <Group.Title title={"T_USR_CSTM_LIST"} titleSize={2}></Group.Title>
                        <Grid {...grid.usrCstmList.grid} data={fetch.getUsrCstmList.data?.usrCstmList} />
                    </Group.Section>
                </Group.Body>
            </Group>
            <Layout direction="row">
                <Layout.Right hidden={btns.pwdAuthChk || btns.elecAprv}>
                    <Button role={"edit"} onClick={() => handler.onEditBtnClick()}>
                        {t("B_EDIT")}
                    </Button>
                </Layout.Right>
                <Layout.Right hidden={!btns.pwdAuthChk}>
                    <Button role="save" onClick={() => handler.onSaveBtnClick()} />
                    {btns.regist && (
                        <>
                            <Button
                                variant="primary"
                                onClick={() => {
                                    setAprvTp("M");
                                    handler.onEditInfoBtnClick();
                                }}
                            >
                                {t("B_APRV_RQST")}
                            </Button>

                            <Button
                                variant="secondary"
                                onClick={() => {
                                    setAprvTp("S");
                                    handler.onSuspdBtnClick();
                                }}
                            >
                                {t("B_APRV_SUSPD")}
                            </Button>
                        </>
                    )}
                </Layout.Right>
            </Layout>
        </Page>
    );
};
